export default "__VITE_ASSET__BtqbxzQp__"